<ng-container screenAnalytics="lotam-view">
    <div class="modal-header no-icon">
        <h3 class="modal-title">
            {{ isEditing ? (isNew ? 'Create' : 'Edit') : 'View' }} LOTAM
        </h3>
        <enhanced-help-switch></enhanced-help-switch>
        <button
            type="button"
            aria-label="Close"
            class="close"
            (click)="onCancel()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <ng-container *ngIf="!isEditing">
        <div
            class="modal-body"
            [ngClass]="{
                'max-height': lotam == null || organisation == null,
            }"
        >
            <lotam-details
                *ngIf="lotam != null && organisation != null"
                class="modal-body-content"
                [lotam]="lotam"
                [organisation]="organisation"
            >
            </lotam-details>
            <ngx-loading [show]="working"></ngx-loading>
        </div>
        <div *ngIf="lotam != null" class="modal-footer">
            <button
                [disabled]="!canDelete || working"
                class="btn btn-danger pull-left"
                type="button"
                (click)="onDelete()"
            >
                <span class="fal fa-trash-alt"></span>
                Delete
            </button>
            <button
                [disabled]="working"
                class="btn btn-default"
                type="button"
                (click)="toggleViewEdit()"
                style="margin-top: 10px"
            >
                Edit
            </button>
            <button
                [disabled]="working"
                class="btn btn-default left-buffer"
                type="button"
                (click)="onShowAcknowledgements()"
                style="margin-top: 10px"
            >
                {{
                    lotam.audience === NoticeDto.Audience.FLIGHT_OPERATIONS
                        ? 'Show Affected Missions'
                        : 'Show All Acknowledgements'
                }}
            </button>
            <div
                *ngIf="
                    lotam.audience !== NoticeDto.Audience.FLIGHT_OPERATIONS &&
                    lotam.requiresAcknowledgement
                "
                class="checkbox acknowledge-checkbox-container pull-right left-buffer"
                [ngClass]="{
                    complete: lotam.isAcknowledged,
                    incomplete: !lotam.isAcknowledged
                }"
                style="min-width: 140px; margin-bottom: 0"
            >
                <label
                    [ngClass]="{
                        acknowledged: lotam.isAcknowledged
                    }"
                >
                    <input
                        type="checkbox"
                        [ngModel]="lotam.isAcknowledged"
                        [disabled]="working"
                        (click)="onAcknowledge($event)"
                    />
                    <span class="cr"
                        ><i class="cr-icon glyphicon glyphicon-ok"></i
                    ></span>
                    {{ lotam.isAcknowledged ? 'Acknowledged' : 'Acknowledge' }}
                </label>
            </div>
        </div>
    </ng-container>
    <lotam-edit
        #lotamEdit
        *ngIf="isEditing && organisation != null"
        [lotam]="isNew ? undefined : lotam"
        [organisation]="organisation"
        [isNew]="isNew"
        (editingCancelled)="onEditingCancelled()"
        (update)="onLotamUpdated($event)"
    >
    </lotam-edit>
</ng-container>
